import { GetStaticPropsContext } from 'next';

import { getBlogPostStaticPaths, getBlogPostStaticProps } from '@backend';

import { BlogPostPage, BlogPostPageProps } from '@components/BlogPostPage';

function BlogPage(pageProps: BlogPostPageProps): JSX.Element {
  return <BlogPostPage {...pageProps} />;
}

export async function getStaticPaths() {
  const paths = await getBlogPostStaticPaths();
  return paths;
}

export async function getStaticProps({ params, preview }: GetStaticPropsContext) {
  if (!params?.slug) return { notFound: true };

  const slugArray = Array.isArray(params.slug) ? params.slug : [params.slug];
  const props = await getBlogPostStaticProps(`/blog/${slugArray.join('/')}`, preview);

  return props;
}

export default BlogPage;
